/* global angular */
(function () {
    "use strict";
    var FILE_UPLOAD_SERVICE_PATH = om.config.build.baseUrl + "/documents";

    angular.module('ui.order.orderItemCard.orderItemFiles.fileService', [])
        .service('fileService', function ($q, toastr, $http, checkDuplicatesService) {
            var gvUploadSessionId = null;
            var createUploadSession = function (file, orderItemId, fileId, customName) {
                return $http.post(FILE_UPLOAD_SERVICE_PATH + "/init-upload", {
                    "Id": fileId,
                    "FileName": customName ? customName : file.name,
                    "FileSize": file.size,
                    "OrderItemIds": [orderItemId]
                })
                    .then(function (result) {
                        gvUploadSessionId = result;
                        return {uploadId: result.data, file: file};
                    }, function (error) {
                        toastr.error(error.statusText, error.status.toString());
                    });
            };
            var uploadFile = function (uploadSessionId, file, chunkSize, batchSize, cancelled, progress) {

                var finalChunk = false;
                var uploaded = 0;
                var size = file.size;
                var sent = 0;
                var left = size;
                var chunk = 0;
                var progressCallback = typeof progress === "undefined" ? null : progress;
                var deferred = $q.defer();
                var deferredStart = $q.defer();
                var promise = deferredStart.promise;
                deferredStart.resolve({file: file, next: 0, sessionId: uploadSessionId, complete: false});
                while (sent < size) {
                    chunk = left < chunkSize ? left : chunkSize;
                    promise = promise.then(function (result) {
                        if (typeof cancelled == 'function' && cancelled() === true) {
                            $http.post(FILE_UPLOAD_SERVICE_PATH + "/cancel-upload", {"contract": uploadSessionId});
                            return $q.reject("canceled");
                        }
                        var first = result.next;
                        var last = first + chunkSize - 1;
                        if (last > size) {
                            last = size - 1;
                            finalChunk = true
                        }
                        var data = file.slice(first, last + 1);
                        return $http.post(FILE_UPLOAD_SERVICE_PATH + "/upload-data", data, {
                            params: {
                                "contract": uploadSessionId,
                                "finalize": finalChunk
                            }
                        }).then(function (res) {
                            uploaded += last - first + 1;
                            var value = Math.round((uploaded / size) * 100);
                            progressCallback(file, value, uploadSessionId, finalChunk);
                            return {
                                file: file,
                                next: last + 1,
                                sessionId: uploadSessionId
                            };
                        });
                    });
                    sent += chunk;
                    left -= chunk;
                }
                promise = promise.then(function (result) {
                    deferred.resolve(0);
                }, function (reason) {
                    deferred.reject(reason);
                });
                return deferred.promise;
            };
            var uploadFiles = function (files, chunkSize, batchSize, concurrencyLevel, cancelled, progress, orderItemId) {
                if (typeof cancelled == 'function' && cancelled() === true) return null;
                var sessions = [];
                var deferred = $q.defer();
                var deferredInner = $q.defer();
                var promiseInner = deferredInner.promise;
                var next = 0;
                deferredInner.resolve(files[0]);
                checkDuplicatesService.actionToAllFiles = null;
                for (var i = 0; i < files.length; i++) {
                    promiseInner = promiseInner.then(function (result) {
                        if (result == null || typeof cancelled == 'function' && cancelled() === true) return null;
                        var id = checkDuplicatesService.isDuplicate(result.name);
                        if (id) {
                            var pauseDeferred = $q.defer();

                            checkDuplicatesService.file = {fileObject: result, id: id};
                            if (checkDuplicatesService.actionToAllFiles) {
                                pauseDeferred.resolve();
                            }
                            else {
                                checkDuplicatesService.pauseDeferred = pauseDeferred;
                                checkDuplicatesService.openConflictWindow(result.name);

                            }
                            //checkDuplicatesService.handlePause(pauseDeferred);
                            return pauseDeferred.promise;
                        }
                            return result;
                        }).then(function (result) {
                        if ((typeof cancelled == 'function' && cancelled() === true)) return $q.reject("canceled");
                        if (!result) {
                            var action;
                            if (checkDuplicatesService.actionToAllFiles) {
                                action = checkDuplicatesService.actionToAllFiles;
                            } else {
                                action = checkDuplicatesService.action;
                            }

                            switch (action) {
                                case "replace":
                                    return createUploadSession(checkDuplicatesService.file.fileObject, orderItemId, checkDuplicatesService.file.id);
                                    break;
                                case "addcopy":
                                    var generated = checkDuplicatesService.generateNewName(checkDuplicatesService.file.fileObject.name);
                                    return createUploadSession(checkDuplicatesService.file.fileObject, orderItemId, 0, generated);
                                case "skip":
                                    progress(checkDuplicatesService.file.fileObject, undefined, null, false, true);
                                    return $q.reject("skipped");
                            }
                        } else {
                            return createUploadSession(result, orderItemId);
                        }
                    })
                        .then(function (result) {
                            if ((typeof cancelled == 'function' && cancelled() === true) || result == null) return $q.reject("canceled");
                            return uploadFile(result.uploadId, files[next], chunkSize, batchSize, cancelled, function (file, value, sessionId, isFinished) {
                                if (value == 100) sessions.push({file: file, sessionId: sessionId});
                                if (typeof progress !== 'undefined') progress(file, value, sessionId, isFinished);
                            }).then(function (result) {
                                next = next + 1;
                                if (next > files.length) return null;
                                return files[next];
                            });
                        }, function (error) {
                            if (error == "skipped") {
                                next = next + 1;
                                if (next > files.length) return null;
                                return files[next];
                                return "ok";
                            }
                        });
                }

                promiseInner.then(function (result) {
                    deferred.resolve(sessions);
                }, function (reason) {
                    deferred.reject(reason);
                });
                return deferred.promise;
            };
            angular.extend(this, {
                createUploadSession: createUploadSession,
                uploadFiles: uploadFiles
            });
        }
    );
})();
